module.exports = __webpack_public_path__ + "static/juvenplans@3x.817f8c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/membership/juvenplans@3x.png
// module id = 729
// module chunks = 92562407457355